module.exports = __webpack_public_path__ + "img/cc-icon.d0be668b.png";